// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBox_diet_container__1d6mq","customSizeSpan":"CheckBox_diet_customSizeSpan__2ogtf"};